<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { NumberFieldInput } from 'reka-ui'
import { computed, inject } from 'vue'
import { cn } from '#ui-kit/lib/utils'
import { INPUT_GROUP_KEY } from '#ui-kit/ui/input-group'
import { NUMBER_FIELD_CONTENT_KEY } from './NumberFieldContent.vue'

defineOptions({
  inheritAttrs: false,
})

const props = defineProps<{
  class?: HTMLAttributes['class']
}>()

const group = inject(INPUT_GROUP_KEY, null)
const content = inject(NUMBER_FIELD_CONTENT_KEY, null)

// Only set when true: a fallthrough `disabled: undefined` would clobber the value reka derives from NumberField.
const groupAttrs = computed(() => ({
  ...(group?.disabled.value || content?.disabled.value ? { disabled: true } : {}),
  ...(group?.error.value || content?.error.value ? { 'aria-invalid': true } : {}),
}))
</script>

<template>
  <NumberFieldInput
    v-bind="{ ...$attrs, ...groupAttrs }"
    :class="
      cn(
        'grow w-full min-w-0',
        'border-0 ring-0 outline-0',
        'focus:border-0 focus:ring-0 focus:outline-0 focus-visible:outline-hidden',
        'p-0! bg-transparent!',
        'placeholder:text-placeholder disabled:cursor-not-allowed',
        props.class,
      )
    "
  />
</template>
